<template>
    <DropdownInput
        :label="this.label"
        v-model="this.localModelValue"
        :v="this.v"
        :options="this.dateOptions"
        remove-empty-option="true"
    />
</template>
<script>
    import api from "@/services/api";
    import DropdownInput from '@/components/DropdownInput.vue';

    export default {
        props: {
            label: {
                default: 'When are you sending this to us?',
            },
            v: {
                required: true,
            },
            account_id: {
                required: true,
            },
            modelValue: {
                required: true,
            },
        },
        data() {
            return {
                dates: [],
            }
        },
        components: {
            DropdownInput,
        },
        computed: {
            localModelValue: {
                get() {
                    return this.modelValue
                },
                set(newValue) {
                    this.$emit('update:modelValue', newValue)
                },
            },
            dateOptions() {
                return this.dates.map((date) => { return {
                    id: date.date,
                    label: date.label,
                }});
            },
        },
        emits: ['update:modelValue'],
        watch: {
            account_id() {
                this.fetchSendingDates();
            },
        },
        mounted () {
            this.fetchSendingDates();
        },
        methods: {
            fetchSendingDates: function () {
                // The account is picked on the form, so there's nothing to offer until it is.
                if (!this.account_id) {
                    this.dates = [];
                    return;
                }

                api
                .get('/api/v1/orders/sending-dates', {
                    params: {
                        account_id: this.account_id,
                    }
                })
                .then((response) => {
                    this.dates = response.data.dates;
                    this.selectDefaultDate();
                })
                .catch(() => {
                    console.log('Catch sending dates error');
                });
            },
            // Keep the dentist's choice while it is still on offer, otherwise preselect the API's default.
            selectDefaultDate: function () {
                if (this.localModelValue && this.dates.some((date) => date.date === this.localModelValue)) {
                    return;
                }

                var defaultDate = this.dates.find((date) => date.is_default);

                this.localModelValue = defaultDate ? defaultDate.date : '';
            },
        }
    }
</script>
